import { Component, ViewChild } from '@angular/core';
import { ConfirmationService, MessageService } from 'primeng/api';
import { lastValueFrom } from 'rxjs';
import {
  BfluenceIntegrityControllerService,
  UnregisteredSubCommission
} from 'src/app/admin-api';
import { TableColumn, TableComponent } from 'src/app/components/table';
import { AppDialogService } from 'src/app/services/dialog.service';
import { LoaderService } from 'src/app/services/loader.service';

@Component({
  selector: 'app-unregistered-sub-commission',
  templateUrl: './unregistered-sub-commission.component.html',
  styleUrl: './unregistered-sub-commission.component.scss',
  providers: [ConfirmationService, MessageService]
})
export class UnregisteredSubCommissionComponent {
  @ViewChild(TableComponent) table: TableComponent;

  columns: Array<TableColumn> = [
    new TableColumn('', '', false, 'checkbox'),
    new TableColumn('SubscriberCouponId', 'subscriberCouponId', true, 'number'),
    new TableColumn(
      'InviterPersonid',
      'inviterPersonid',
      true,
      'number',
      '/users/person/',
      'inviterPersonid'
    ),
    new TableColumn('CouponId', 'couponId', true, 'number'),
    new TableColumn('CouponName', 'couponName', true, 'text'),
    new TableColumn('Name', 'name', true, 'text'),
    new TableColumn(
      'InvitedSubscriberId',
      'invitedSubscriberId',
      true,
      'number',
      '/users/subscribers/',
      'invitedSubscriberId'
    ),
    new TableColumn('SubscriptionTypeId', 'subscriptionTypeId', true, 'number')
  ];

  constructor(
    public bfluenceIntegrityService: BfluenceIntegrityControllerService,
    private messageService: MessageService,
    private confirmationService: ConfirmationService
  ) {}

  markAsResolved(elements: Array<UnregisteredSubCommission>): void {
    this.confirmationService.confirm({
      acceptLabel: 'Sim',
      rejectLabel: 'Não',
      rejectButtonStyleClass: 'p-button-danger',
      message: 'Deseja ajustar estas comissões?',
      header: 'Ajustar Comissões',
      accept: async () => {
        LoaderService.showLoader();
        try {
          await lastValueFrom(
            this.bfluenceIntegrityService.fixUnregisteredSubCommission(elements)
          );
          await this.table.refresh(true);
          this.messageService.add({
            summary: 'Sucesso',
            detail: elements.length + ' marcado(s) como resolvido(s)',
            severity: 'success'
          });
          LoaderService.showLoader(false);
        } catch (error) {
          LoaderService.showLoader(false);
          AppDialogService.showErrorDialog(error);
        }
      }
    });
  }
}
